const BASE = 'https://api.simia.digital/missao/api'

function getToken() { return localStorage.getItem('missao_token') || '' }
function setToken(t: string) { localStorage.setItem('missao_token', t) }
function clearToken() { localStorage.removeItem('missao_token') }

async function apiFetch(path: string, opts: RequestInit = {}) {
  const r = await fetch(`${BASE}${path}`, {
    ...opts,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${getToken()}`,
      ...opts.headers,
    },
  })
  const data = await r.json()
  if (!r.ok) throw new Error(data.error || 'Erro desconhecido')
  return data
}

export const api = {
  register: (email: string, password: string, name: string) =>
    apiFetch('/register/', { method: 'POST', body: JSON.stringify({ email, password, name }) }),

  login: (email: string, password: string) =>
    apiFetch('/login/', { method: 'POST', body: JSON.stringify({ email, password }) }),

  me: () => apiFetch('/me/'),

  saveConfig: (data: { dm_message: string; comment_reply: string; is_active: boolean; reply_active?: boolean }) =>
    apiFetch('/save/', { method: 'POST', body: JSON.stringify(data) }),

  disconnect: () => apiFetch('/disconnect/', { method: 'POST' }),

  getToken,
  setToken,
  clearToken,

  getOAuthUrl: () => `https://api.simia.digital/missao/oauth/start/?token=${getToken()}`,
}
